module.exports = __webpack_public_path__ + "static/media/TUNE_6740.a7d30176.jpg";